var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useCallback } from "react";
import { useToggle } from "@react-md/utils";
/**
 * @internal
 */
export function useFocusState(_a) {
    var onFocus = _a.onFocus, onBlur = _a.onBlur;
    var _b = __read(useToggle(false), 3), focused = _b[0], setFocused = _b[1], setBlurred = _b[2];
    var handleFocus = useCallback(function (event) {
        if (onFocus) {
            onFocus(event);
        }
        setFocused();
    }, [setFocused, onFocus]);
    var handleBlur = useCallback(function (event) {
        if (onBlur) {
            onBlur(event);
        }
        setBlurred();
    }, [setBlurred, onBlur]);
    return [focused, handleFocus, handleBlur];
}
//# sourceMappingURL=useFocusState.js.map